import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { salesByUserSearchSchema } from '../../features/reports/operational-search'
import { SalesByUserPage } from '../../features/reports/sales-by-user-page'

export const Route = createFileRoute('/_app/sales-by-user')({
  staticData: { crumb: 'salesByUser' },
  validateSearch: salesByUserSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: SalesByUserPage,
})
